<main id="alert-settings">
  <div
    class="alerts-page-container"
    rvSpinner="alert-loader"
    [rvShowSpinner]="alertsService.isLoading"
  >
    <div id="alerts-page-body" class="alerts-page-body">
      <div
        class="tw-max-w-[800px] tw-mx-auto tw-flex tw-flex-col tw-gap-[16px]"
      >
        @if (alertsService.apiError) {
          <div
            id="errorBox"
            class="alert alert-danger alert-message"
            role="alert"
          >
            <div class="tw-flex tw-items-center tw-gap-[8px]">
              <mat-icon
                aria-hidden="true"
                svgIcon="error-filled"
                class="small tw-text-red-600"
              ></mat-icon>
              <span
                ><strong>{{ alertsService.errorMessage }}</strong>
                {{ alertsService.apiError }}
              </span>
            </div>
          </div>
        }

        <div class="alert-card">
          <div class="flex-row tw-items-center tw-justify-between tw-mb-[10px]">
            <h2 id="alerts-toggle-label" class="alerts-heading tw-m-0">
              Enable CAP Alerts
            </h2>

            <mat-slide-toggle
              id="alerts-toggle"
              [checked]="alertsOn"
              (change)="toggleAlerts()"
              [disabled]="!userStateService.hasPermission('ua')"
              aria-labelledby="alerts-toggle-label"
            ></mat-slide-toggle>
          </div>

          <div>
            Enable Common Alerting Protocol (CAP) to automatically override
            scheduled content with emergency visual and audio notifications from
            your alert provider.
          </div>

          @if (!alertsOn && templates && templates.length > 0) {
            <hr class="alert-template-preview-divider" />

            <h2 class="alerts-heading alert-template-preview-heading">
              Templates
            </h2>

            <ul class="alert-template-preview-grid">
              @for (template of templates; track template; let i = $index) {
                @if (template.imageUrl) {
                  <li class="alert-template-preview-item">
                    <img
                      class="alert-template-preview-image"
                      loading="lazy"
                      [src]="template.imageUrl"
                      attr.aria-describedby="alert-template-{{ i }}-label"
                      alt="{{ template.imageAlt || template.name }}"
                    />

                    <span>{{ template.name }}</span>
                  </li>
                }
              }
            </ul>
          }
        </div>

        @if (
          alertsService.missingTemplate &&
          alertsService.alertSettings.templateProductCode === ''
        ) {
          <div class="alert alert-warning alert-message">
            <div class="tw-flex tw-items-center tw-gap-[8px]">
              <mat-icon
                aria-hidden="true"
                svgIcon="warning-filled"
                class="small tw-text-yellow-500"
              ></mat-icon>
              {{ WARNING_MISSING_TEMPLATE }}
            </div>
          </div>
        }

        @if (alertsOn) {
          @if (!featureAvailable) {
            <div class="alert alert-warning alert-message">
              <div class="tw-flex tw-items-center tw-gap-[8px]">
                <mat-icon
                  aria-hidden="true"
                  svgIcon="warning-filled"
                  class="small tw-text-yellow-500"
                ></mat-icon>
                @if (featureAvailable === null) {
                  {{ WARNING_NOT_SUBSCRIBED }}
                } @else {
                  {{ WARNING_NOT_AVAILABLE }}
                }
              </div>
              <div class="tw-flex tw-flex-grow"></div>
              <button
                matButton="outlined"
                class="button-width--fit button-height--small"
                (click)="openUpgradeModal()"
              >
                Learn More
              </button>
            </div>
          }
          <div
            class="alert-card"
            [shown]="featureAvailable"
            *requireRole="'ua'"
          >
            <h2 class="alerts-heading mt-0">Terms &amp; Conditions</h2>
            <p id="termsText">
              “Common Alerting Protocol Emergency Messaging” (“CAP Alerts”) is a
              system that allows the dissemination of emergency messages over a
              variety of public alerting systems.
            </p>
            <p id="termsText2">
              CAP Alerts is provided by independent third parties (“CAP Alerts
              Providers”) whom you select. You shall be solely responsible for
              ensuring the CAP Alerts service you select is configured, tested,
              and maintained to meet your needs. Neither Rise Vision nor
              hardware manufacturer of hardware products which include, display
              or otherwise utilize Rise Vision software, or distributors or
              resellers of Rise Vision software, are sellers of CAP Alerts and
              none provide any warranty or assume any liability for the
              performance, accuracy, or timely delivery of CAP Alerts, including
              connectivity failures, user configuration issues, or false,
              hacked, erroneous, missed, or delayed CAP Alerts.
            </p>
            <p id="termsText3">
              Rise Vision suggests that before implementing CAP Emergency
              Messaging you and/or your CAP Alerts Provider (a) connect to Rise
              Vision with the more secure HTTPS, not HTTP; (b) require an
              Authentication Name and Password for the connection; (c) ensure
              that your Displays have a stable internet connection for timely
              receipt of CAP Emergency Messaging; and (d) conduct periodic
              testing according to your own policies.
            </p>
            <div class="form-group u_remove-bottom i-accept-flag">
              <mat-checkbox
                id="termsAcceptedCheckbox"
                (ngModelChange)="termsAccepted = $event"
                [ngModel]="termsAccepted"
                [disabled]="fieldsDisabled"
                aria-labelledby="iAcceptLabel"
                [ariaChecked]="termsAccepted"
                ariaCheckedElementId="termsAcceptedCheckbox-input"
              />
              <label
                id="iAcceptLabel"
                for="termsAcceptedCheckbox-input"
                class="mb-0 u_clickable"
                >I accept this Disclaimer and Acknowledgement
                <span class="iAcceptLabel-required">(Required)</span>
              </label>
            </div>
          </div>

          <div class="alert-card">
            <h2 class="alerts-heading mt-0">Provider Settings</h2>
            <div class="mb-4">
              <label class="control-label tw-mb-0">Web Service URL</label>
              <div class="flex-row space-between py-2 mb-4">
                <div class="input-group tw-w-full tw-mr-[8px]">
                  <input
                    id="webserviceUrlInput"
                    type="text"
                    class="form-control tw-bg-gray-50 tw-text-gray-500 tw-w-full tw-pointer-events-none"
                    tabindex="-1"
                    [ngModel]="alertUrl"
                    [readonly]="true"
                  />

                  <span class="input-group-addon !tw-border-gray-300">
                    <button
                      mat-icon-button
                      [focus-outline]="2"
                      type="button"
                      class="tw-w-[20px] tw-h-[20px]"
                      aria-label="Copy alert URL"
                      (click)="copyAlertUrl()"
                      [disabled]="fieldsDisabled"
                      matTooltip="Copy"
                      matTooltipClass="menu-tooltip"
                    >
                      <mat-icon
                        svgIcon="copy"
                        class="tw-text-gray-700"
                        aria-hidden="true"
                      />
                    </button>
                  </span>
                </div>

                <button
                  matButton="outlined"
                  id="urlResetButton"
                  class="button-width--fit"
                  type="button"
                  (click)="resetAlertUrl()"
                  [disabled]="fieldsDisabled"
                >
                  Refresh
                </button>
              </div>
            </div>
            <ul class="alert-provider-authentication-grid">
              <li class="alert-provider-authentication-item">
                <label class="control-label" for="usernameInput"
                  >Authentication Name</label
                >
                <input
                  id="usernameInput"
                  type="text"
                  class="form-control"
                  [(ngModel)]="alertsService.alertSettings.userName"
                  [disabled]="fieldsDisabled"
                />
              </li>
              <li class="alert-provider-authentication-item">
                <label class="control-label" for="passwordInput"
                  >Authentication Password</label
                >
                <input
                  id="passwordInput"
                  type="password"
                  class="form-control"
                  [(ngModel)]="alertsService.alertSettings.password"
                  [disabled]="fieldsDisabled"
                />
              </li>
            </ul>
          </div>

          <div class="alert-card">
            <h2 class="alerts-heading mt-0">Template</h2>
            <ul
              class="template-list alert-template-grid"
              [shown]="templates && templates.length > 0"
            >
              @for (template of templates; track template; let i = $index) {
                <li
                  class="alert-template-card"
                  [class.alert-template-card-selected]="
                    alertsService.alertSettings.templateProductCode ===
                    template.productCode
                  "
                  [class.alert-template-card-disabled]="
                    alertsService.alertSettings.templateProductCode ===
                      template.productCode && fieldsDisabled
                  "
                  (click)="setTemplate(template.productCode)"
                >
                  <div class="template-image mb-3">
                    @if (template.imageUrl) {
                      <img
                        loading="lazy"
                        [src]="template.imageUrl"
                        attr.aria-describedby="alert-template-{{ i }}-label"
                        alt="{{ template.imageAlt || template.name }}"
                      />
                    }
                  </div>
                  <div class="alert-template-card__choice">
                    <mat-checkbox
                      [class.appear-enabled]="!fieldsDisabled"
                      [ngModel]="
                        alertsService.alertSettings.templateProductCode ===
                        template.productCode
                      "
                      [disabled]="
                        fieldsDisabled ||
                        alertsService.alertSettings.templateProductCode ===
                          template.productCode
                      "
                      (ngModelChange)="setTemplate(template.productCode)"
                      aria-labelledby="alert-template-{{ i }}-label"
                      [ariaChecked]="
                        alertsService.alertSettings.templateProductCode ===
                        template.productCode
                      "
                      ariaCheckedElementId="alert-template-{{ i }}-input"
                    />
                    <label
                      class="u_clickable"
                      for="alert-template-{{ i }}-input"
                      id="alert-template-{{ i }}-label"
                      >{{ template.name }}</label
                    >
                  </div>
                </li>
              }
            </ul>

            @if (
              (alertsService.alertSettings.presentationId &&
                !alertsService.alertSettings.templateProductCode) ||
              userStateService.isRiseAdmin()
            ) {
              <div
                class="tw-flex tw-flex-row tw-items-center tw-space-between alert-template-card alert-custom-presentation"
                [class.alert-template-card-selected]="
                  isCustomPresentationSelected
                "
                [class.tw-pointer-events-none]="fieldsDisabled"
                (click)="handleCustomPresentationSelection($event)"
              >
                <mat-checkbox
                  id="custom-presentation"
                  [checked]="isCustomPresentationSelected"
                  [disabled]="fieldsDisabled"
                  (change)="handleCustomPresentationSelection($event)"
                  aria-labelledby="custom-presentation-label"
                  [ariaChecked]="isCustomPresentationSelected"
                  ariaCheckedElementId="custom-presentation-input"
                />
                <label
                  class="u_clickable mb-0 tw-ml-[5px]"
                  id="custom-presentation-label"
                >
                  {{
                    alertsService.alertSettings.presentationName ||
                      'Custom Presentation'
                  }}
                </label>
                <streamline-icon
                  aria-hidden="true"
                  [shown]="
                    userStateService.isRiseAdmin() &&
                    !alertsService.alertSettings.presentationId
                  "
                  [width]="16"
                  [height]="16"
                  name="riseLogo"
                  class="flex-row tw-ml-[12px] rise-green"
                ></streamline-icon>
                <div class="tw-flex-grow"></div>
                <div class="tw-bg-white tw-rounded-[6px] tw-ml-6">
                  <button
                    matButton="outlined"
                    (click)="alertsService.changePresentation()"
                    [disabled]="fieldsDisabled"
                    [shown]="
                      userStateService.isRiseAdmin() &&
                      alertsService.alertSettings.presentationId
                    "
                    class="button-width--fit rise-admin-only"
                  >
                    Change
                  </button>
                </div>
              </div>
            }
          </div>

          <div *requireRole="'da'" class="alert-card">
            <div
              class="flex-row tw-items-center tw-justify-between tw-mb-[10px]"
            >
              <h2 class="alerts-heading tw-m-0">Audio</h2>
              <div class="mt-2 flex-row align-center">
                <mat-slide-toggle
                  id="enable-audio"
                  [(ngModel)]="alertsService.alertSettings.enableAudio"
                  [disabled]="fieldsDisabled"
                  aria-labelledby="enable-audio-label"
                >
                </mat-slide-toggle>
              </div>
            </div>

            <span id="enable-audio-label">Play alert sound</span>
          </div>

          <div class="alert-card">
            <div
              class="flex-row tw-items-center tw-justify-between tw-mb-[10px]"
            >
              <h2 id="textToShowLabel" class="alerts-heading tw-m-0">
                Alert Content
              </h2>
            </div>
            <div>
              @for (item of alertsService.textFieldsValues; track item) {
                <div class="alert-distribution-item">
                  <mat-checkbox
                    id="textFieldsCheckbox-{{ item.key }}"
                    (change)="
                      setCheckboxList('textFields', item.key, $event.checked)
                    "
                    [checked]="getCheckboxList('textFields', item.key)"
                    [disabled]="fieldsDisabled"
                    aria-labelledby="textFieldsCheckbox-{{ item.key }}-label"
                    [ariaChecked]="getCheckboxList('textFields', item.key)"
                    ariaCheckedElementId="textFieldsCheckbox-{{
                      item.key
                    }}-input"
                    class="tw-mr-[16px]"
                  />
                  <label
                    class="font-weight-normal u_nowrap mb-0 u_clickable"
                    for="textFieldsCheckbox-{{ item.key }}-input"
                    id="textFieldsCheckbox-{{ item.key }}-label"
                    >{{ item.label }}</label
                  >
                </div>
              }
            </div>
          </div>

          <div class="alert-card">
            <div
              class="flex-row tw-items-start tw-justify-between tw-mb-[10px]"
            >
              <h2 class="alerts-heading tw-m-0">Distribution</h2>
            </div>

            <distribution-selector
              [(distribution)]="alertsService.alertSettings.distribution"
              [(distributeToAll)]="alertsService.alertSettings.distributeToAll"
              [(subcompanyDistribution)]="
                alertsService.alertSettings.subcompanyDistribution
              "
              [(distributeToSubcompanies)]="
                alertsService.alertSettings.distributeToSubcompanies
              "
              [enableSubcompanies]="true"
              [(subcompanyDistributeToAll)]="
                alertsService.alertSettings.subcompanyDistributeToAll
              "
              [enableSubcompanyDistributeToAll]="true"
              [enableFeatureCheck]="false"
              [readonly]="fieldsDisabled"
              inputId="-alerts"
              [showLabel]="false"
            >
            </distribution-selector>
          </div>

          <div class="alert-card">
            <div class="alert-card-section-header">
              <h2 class="alerts-heading my-0" id="default-expiry-label">
                Default Expiry
              </h2>
              <div class="input-group">
                <input
                  id="defaultExpiryInput"
                  type="number"
                  role="spinbutton"
                  class="form-control tw-w-[100px]"
                  [(ngModel)]="alertsService.alertSettings.defaultExpiry"
                  [disabled]="fieldsDisabled"
                  [attr.aria-valuenow]="
                    alertsService.alertSettings.defaultExpiry
                  "
                  min="0"
                  aria-valuemin="0"
                  [attr.aria-invalid]="
                    alertsService.alertSettings.defaultExpiry < 0
                  "
                  aria-labelledby="default-expiry-label"
                  aria-describedby="default-expiry-label-description"
                  (input)="onDefaultExpiryInput($event)"
                  (keydown)="onDefaultExpiryKeydown($event)"
                />
                <span class="input-group-addon">
                  <div class="u_nowrap">Minutes</div>
                </span>
              </div>
            </div>
            <div id="default-expiry-label-description">
              Fallback duration before alerts clear and scheduled content
              resumes.
            </div>
          </div>

          <div class="alert-card">
            <mat-expansion-panel
              class="expansion-panel-flush mat-elevation-z0"
              [expanded]="showFilters"
            >
              <mat-expansion-panel-header
                class="tw-pl-0 tw-pr-[5px] !tw-h-[20px]"
              >
                <h2 class="alerts-heading my-0">Filters</h2>
              </mat-expansion-panel-header>
              <div class="panel-body tw-pl-0 tw-pr-[1px]" id="filtersContainer">
                <div class="row mb-2">
                  <div
                    class="form-group col-xs-12 col-sm-4"
                    id="senderContainer"
                  >
                    <label class="control-label" for="allowedSenders"
                      >Sender</label
                    >
                    <input
                      id="allowedSenders"
                      type="text"
                      class="form-control"
                      [(ngModel)]="allowedSendersCsv"
                      [disabled]="fieldsDisabled"
                      (ngModelChange)="
                        parseCsvList(allowedSendersCsv, 'allowedSenders')
                      "
                    />
                  </div>
                  <!--form-group-->
                  <div
                    class="form-group col-xs-12 col-sm-4"
                    id="handlingContainer"
                  >
                    <label class="control-label" for="allowedHandlingCodes"
                      >Handling</label
                    >
                    <input
                      id="allowedHandlingCodes"
                      type="text"
                      class="form-control"
                      [(ngModel)]="allowedHandlingCodesCsv"
                      [disabled]="fieldsDisabled"
                      (ngModelChange)="
                        parseCsvList(
                          allowedHandlingCodesCsv,
                          'allowedHandlingCodes'
                        )
                      "
                    />
                  </div>
                  <!--form-group-->
                  <div class="form-group col-xs-12 col-sm-4" id="codeContainer">
                    <label class="control-label" for="allowedEventCodes"
                      >Code</label
                    >
                    <input
                      id="allowedEventCodes"
                      type="text"
                      class="form-control"
                      [(ngModel)]="allowedEventCodesCsv"
                      [disabled]="fieldsDisabled"
                      (ngModelChange)="
                        parseCsvList(allowedEventCodesCsv, 'allowedEventCodes')
                      "
                    />
                  </div>
                  <!--form-group-->
                </div>
                <div class="row">
                  <div class="col-xs-6 col-sm-3 mb-3">
                    <label class="control-label" id="statusLabel">Status</label>
                    @for (
                      item of alertsService.allowedStatusesValues;
                      track item
                    ) {
                      <div>
                        <mat-checkbox
                          id="statusesCheckbox-{{ item.key }}"
                          (ngModelChange)="
                            setCheckboxList('allowedStatuses', item.key, $event)
                          "
                          [ngModel]="
                            getCheckboxList('allowedStatuses', item.key)
                          "
                          [disabled]="fieldsDisabled"
                          aria-labelledby="statusesCheckbox-{{
                            item.key
                          }}-label"
                          [ariaChecked]="
                            getCheckboxList('allowedStatuses', item.key)
                          "
                          ariaCheckedElementId="statusesCheckbox-{{
                            item.key
                          }}-input"
                        />
                        <label
                          class="font-weight-normal u_nowrap mb-0 u_clickable"
                          for="statusesCheckbox-{{ item.key }}-input"
                          id="statusesCheckbox-{{ item.key }}-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    }
                  </div>
                  <div class="col-xs-6 col-sm-3 mb-3">
                    <label class="control-label" id="urgencyLabel"
                      >Urgency</label
                    >
                    @for (
                      item of alertsService.allowedUrgenciesValues;
                      track item
                    ) {
                      <div>
                        <mat-checkbox
                          id="urgenciesCheckbox-{{ item.key }}"
                          (ngModelChange)="
                            setCheckboxList(
                              'allowedUrgencies',
                              item.key,
                              $event
                            )
                          "
                          [ngModel]="
                            getCheckboxList('allowedUrgencies', item.key)
                          "
                          [disabled]="fieldsDisabled"
                          aria-labelledby="urgenciesCheckbox-{{
                            item.key
                          }}-label"
                          [ariaChecked]="
                            getCheckboxList('allowedUrgencies', item.key)
                          "
                          ariaCheckedElementId="urgenciesCheckbox-{{
                            item.key
                          }}-input"
                        />
                        <label
                          class="font-weight-normal u_nowrap mb-0 u_clickable"
                          for="urgenciesCheckbox-{{ item.key }}-input"
                          id="urgenciesCheckbox-{{ item.key }}-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    }
                  </div>
                  <div class="col-xs-6 col-sm-3 mb-3">
                    <label class="control-label" id="severityLabel"
                      >Severity</label
                    >
                    @for (
                      item of alertsService.allowedSeveritiesValues;
                      track item
                    ) {
                      <div>
                        <mat-checkbox
                          id="severitiesCheckbox-{{ item.key }}"
                          (ngModelChange)="
                            setCheckboxList(
                              'allowedSeverities',
                              item.key,
                              $event
                            )
                          "
                          [ngModel]="
                            getCheckboxList('allowedSeverities', item.key)
                          "
                          [disabled]="fieldsDisabled"
                          aria-labelledby="severitiesCheckbox-{{
                            item.key
                          }}-label"
                          [ariaChecked]="
                            getCheckboxList('allowedSeverities', item.key)
                          "
                          ariaCheckedElementId="severitiesCheckbox-{{
                            item.key
                          }}-input"
                        />
                        <label
                          class="font-weight-normal u_nowrap mb-0 u_clickable"
                          for="severitiesCheckbox-{{ item.key }}-input"
                          id="severitiesCheckbox-{{ item.key }}-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    }
                  </div>
                  <div class="col-xs-6 col-sm-3 mb-3">
                    <label class="control-label" id="certaintyLabel"
                      >Certainty</label
                    >
                    @for (
                      item of alertsService.allowedCertaintiesValues;
                      track item
                    ) {
                      <div>
                        <mat-checkbox
                          id="certaintiesCheckbox-{{ item.key }}"
                          (ngModelChange)="
                            setCheckboxList(
                              'allowedCertainties',
                              item.key,
                              $event
                            )
                          "
                          [ngModel]="
                            getCheckboxList('allowedCertainties', item.key)
                          "
                          [disabled]="fieldsDisabled"
                          aria-labelledby="certaintiesCheckbox-{{
                            item.key
                          }}-label"
                          [ariaChecked]="
                            getCheckboxList('allowedCertainties', item.key)
                          "
                          ariaCheckedElementId="certaintiesCheckbox-{{
                            item.key
                          }}-input"
                        />
                        <label
                          class="font-weight-normal u_nowrap mb-0 u_clickable"
                          for="certaintiesCheckbox-{{ item.key }}-input"
                          id="certaintiesCheckbox-{{ item.key }}-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    }
                  </div>
                </div>
                <br />
                <label class="control-label" id="categoryLabel">Category</label>
                <div class="row">
                  @for (
                    item of alertsService.allowedCategoriesValues;
                    track item
                  ) {
                    <div class="col-xs-6 col-sm-3 flex-row align-start">
                      <mat-checkbox
                        id="categoriesCheckbox-{{ item.key }}"
                        (ngModelChange)="
                          setCheckboxList('allowedCategories', item.key, $event)
                        "
                        [ngModel]="
                          getCheckboxList('allowedCategories', item.key)
                        "
                        [disabled]="fieldsDisabled"
                        aria-labelledby="categoriesCheckbox-{{
                          item.key
                        }}-label"
                        [ariaChecked]="
                          getCheckboxList('allowedCategories', item.key)
                        "
                        ariaCheckedElementId="categoriesCheckbox-{{
                          item.key
                        }}-input"
                      />
                      <label
                        class="font-weight-normal mt-2 mb-0 u_clickable text-break-spaces"
                        for="categoriesCheckbox-{{ item.key }}-input"
                        id="categoriesCheckbox-{{ item.key }}-label"
                        >{{ item.label }}</label
                      >
                    </div>
                  }
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        }
      </div>
    </div>

    @if (showCommonActions) {
      <div class="alerts-page-footer">
        <common-actions
          [actions]="actions"
          [saving]="alertsService.isLoading"
          [changeDate]="alertsService.changeDate"
          [changedBy]="alertsService.changedBy"
        >
        </common-actions>
      </div>
    }
  </div>
</main>
